'use client';

import { createContext } from 'react';

import { WebUiGlobalContextType } from './types';

// ----------------------------------------------------------------------

export const WebUiGlobalContext = createContext({} as WebUiGlobalContextType);
